import DashboardChart from "./dashboard-chart.vue";

export default DashboardChart;



// WEBPACK FOOTER //
// ./src/components/_dashboard/chart/index.js